<template>
  <li>
    <div
      class="treeview__level"
      :style="
        `--bg-circle-color:${bgColor};--border-circle-color:${borderColor};`
      "
    >
      <span class="level-title">{{ item.item.type }}</span>
      <div class="actions-component rounded d-flex">
        <div class="action">
          <b-icon-plus-circle-fill
            @click="addItem(item.item.id)"
          ></b-icon-plus-circle-fill>
        </div>
        <div class="action">
          <b-icon-pencil @click="editItem(item.item)"></b-icon-pencil>
        </div>
        <div class="action">
          <b-icon-trash @click="deleteItem(item.item.id)"></b-icon-trash>
        </div>
      </div>
    </div>
    <ul class="treeview-ul">
      <group-session-type-crud-item
        v-for="subItem in item.subItems"
        :key="subItem.item.id"
        :item="subItem"
        @add-item="addItem($event.parentId)"
        @edit-item="editItem($event.data)"
        @delete-item="deleteItem($event.id)"
        :level="level + 1"
      />
    </ul>
  </li>
</template>

<script>
import { colors } from "../../config/layout";

export default {
  name: "GroupSessionTypeCrudItem",
  props: ["item", "level"],
  methods: {
    addItem(parentId) {
      this.$emit("add-item", { parentId });
    },
    editItem(data) {
      this.$emit("edit-item", { data });
    },
    deleteItem(id) {
      this.$emit("delete-item", { id });
    }
  },
  computed: {
    bgColor() {
      return colors[this.level % colors.length].bg;
    },
    borderColor() {
      return colors[this.level % colors.length].border;
    }
  }
};
</script>

<style scoped>
.actions-component {
  position: absolute;
  background-color: blue;
  color: white;
  top: -16px;
  line-height: 1.5;
  font-size: 0.8rem;
  right: 6px;
  display: none !important;
  z-index: 5;
}
.treeview__level:hover .actions-component {
  display: flex !important;
}
.treeview__level:hover {
  border: 1px solid blue;
  cursor: pointer;
}
</style>
